(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-styles"] && !Shopify.designMode) return;
  try {
    let pendingFrame = 0;
  let viewportWidth = document.documentElement.clientWidth;
  const controller = new AbortController();
  function alignProductCards() {
    pendingFrame = 0;
    const cards = [...document.querySelectorAll('.ln-unified-card')].filter(card => card.getClientRects().length);
    for (const card of cards) {
      card.style.setProperty('--ln-title-height', '0px');
      card.style.setProperty('--ln-notes-height', '0px');
      card.style.setProperty('--ln-profile-height', '0px');
    }
    const rows = new Map();
    for (const card of cards) {
      const parent = card.closest('.product-grid, .resource-list') || card.parentElement.parentElement;
      const top = Math.round(card.getBoundingClientRect().top);
      let parentRows = rows.get(parent);
      if (!parentRows) { parentRows = new Map(); rows.set(parent, parentRows); }
      let row = parentRows.get(top);
      if (!row) { row = []; parentRows.set(top, row); }
      row.push(card);
    }
    for (const parentRows of rows.values()) {
      for (const row of parentRows.values()) {
        let titleHeight = 0;
        let notesHeight = 0;
        let profileHeight = 0;
        for (const card of row) {
          titleHeight = Math.max(titleHeight, card.querySelector('.ln-card-title')?.getBoundingClientRect().height || 0);
          profileHeight = Math.max(profileHeight, card.querySelector('.ln-card-profile')?.getBoundingClientRect().height || 0);
          notesHeight = Math.max(notesHeight, card.querySelector('.ln-card-notes')?.getBoundingClientRect().height || 0);
        }
        for (const card of row) {
          card.style.setProperty('--ln-title-height', Math.ceil(titleHeight) + 'px');
          card.style.setProperty('--ln-notes-height', Math.ceil(notesHeight) + 'px');
          card.style.setProperty('--ln-profile-height', Math.ceil(profileHeight) + 'px');
        }
      }
    }
  }
  function scheduleAlignment() {
    if (!pendingFrame) pendingFrame = requestAnimationFrame(alignProductCards);
  }
  const observer = new MutationObserver(scheduleAlignment);
  observer.observe(document.body, { childList: true, subtree: true });
  const resizeObserver = new ResizeObserver(() => {
    const width = document.documentElement.clientWidth;
    if (width !== viewportWidth) { viewportWidth = width; scheduleAlignment(); }
  });
  resizeObserver.observe(document.documentElement);
  document.addEventListener('load', scheduleAlignment, { capture: true, signal: controller.signal });
  window.addEventListener('resize', scheduleAlignment, { signal: controller.signal });
  document.addEventListener('shopify:section:load', scheduleAlignment, { signal: controller.signal });
  document.fonts.ready.then(scheduleAlignment);
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    resizeObserver.disconnect();
    controller.abort();
    if (pendingFrame) cancelAnimationFrame(pendingFrame);
  }, { once: true });
  scheduleAlignment();
  } catch(e) { console.error(e); }
})();

})();
